import React, { useEffect } from 'react';
import { VehicleDataForm, vehicleTypeOptions } from '../../../../app/models/Vehicle';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';

type Props = {
    vehicle: VehicleDataForm;
    setVehicle: (vehicle: VehicleDataForm) => void;
    errorFields?: any;
};

const VehicleForm = ({ vehicle, setVehicle, errorFields }: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setVehicle({ ...vehicle, [name]: value });
    };

    return (
        <>
            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Tipo de Vehículo</label>
                <div className="col-md-9">
                    <select
                        name="vehicle_type"
                        id="vehicle_type"
                        className={`form-control ${fieldHasError('vehicle_type')}`}
                        value={vehicle.vehicle_type}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('vehicle_type')}
                    >
                        <option value="">Seleccione un tipo</option>
                        {vehicleTypeOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('vehicle_type')}
                    </div>
                </div>
            </div>

            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Patente</label>
                <div className="col-md-9">
                    <input
                        name="patent"
                        id="patent"
                        type="text"
                        className={`form-control ${fieldHasError('patent')}`}
                        value={vehicle.patent}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('patent')}
                        placeholder="Ingrese la patente del vehículo"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('patent')}
                    </div>
                </div>
            </div>
        </>
    );
};

export default VehicleForm;
